import { ConnectComponent } from '../../_components/ConnectComponent'
import { DeductiblePresenter } from './Deductible.presenter'
import { DeductibleView } from './Deductible.view'

export const Deductible = ConnectComponent(DeductibleView, DeductiblePresenter)
